export default __webpack_public_path__ + "static/media/lights-header.ccfc50a2.jpg";